module.exports = __webpack_public_path__ + "img/9x16_center.94ebedf9.jpg";